// import 'bootstrap/dist/css/bootstrap.min.css';
// import Navbar from './Navbar';
// import Home from './Home.js';
// import Create from './Create';
// import Deposit from './Deposit';
// import Withdraw from './Withdraw';
// import Alldata from './Alldata';
// import {HashRouter,Routes,Route} from 'react-router-dom';
// import userContext from './Context.js';

// function App(){
//   return(<>
//   <HashRouter>
//     <userContext.Provider value={{users:[{"Name":"Pooja",
//                                           "Email":"poojaunnikrishnan25@gmail.com",
//                                           "Password":1234567,
//                                           "Amount":100000
//     }]}}>
//     <Navbar></Navbar>
//     <Routes>
//       <Route path='/Home' element={<Home></Home>}></Route>
//       <Route path='/Create' element={<Create></Create>}></Route>
//       <Route path='/Deposit' element={<Deposit></Deposit>}></Route>
//       <Route path='/Withdraw' element={<Withdraw></Withdraw>}></Route>
//       <Route path='/Alldata' element={<Alldata></Alldata>}></Route>
//     </Routes>
//     </userContext.Provider>
//   </HashRouter> 
//   </>)
// }

// export default App;
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [page, setPage] = useState("home");
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    email: "",
    password: "",
    phone: "",
    name: "",
    amount: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // CREATE USER
  const createUser = () => {
    if (!form.email || !form.password || !form.phone || !form.name) {
      alert("Fill all fields");
      return;
    }

    setUsers([...users, { ...form, balance: 0 }]);
    alert("User Created Successfully");

    setForm({
      email: "",
      password: "",
      phone: "",
      name: "",
      amount: ""
    });
  };

  // DEPOSIT
  const deposit = () => {
    const index = users.findIndex((u) => u.email === form.email);

    if (index === -1 || form.amount <= 0) {
      alert("Enter valid details");
      return;
    }

    const updated = [...users];
    updated[index].balance += Number(form.amount);

    setUsers(updated);
    alert("Successful");
  };

  // WITHDRAW
  const withdraw = () => {
    const index = users.findIndex((u) => u.email === form.email);

    if (index === -1) {
      alert("User not found");
      return;
    }

    if (form.amount <= 0 || form.amount > users[index].balance) {
      alert("Enter valid amount");
      return;
    }

    const updated = [...users];
    updated[index].balance -= Number(form.amount);

    setUsers(updated);
    alert("Withdraw Successful");
  };

  return (
    <div>
      {/* NAVBAR */}
      <nav className="navbar navbar-dark bg-dark navbar-expand-lg">
        <div className="container">
          <span className="navbar-brand">OPERATIONS</span>

          <div>
            <button className="btn btn-outline-light me-2" onClick={() => setPage("home")}>
              Home
            </button>

            <button className="btn btn-outline-light me-2" onClick={() => setPage("create")}>
              Create User
            </button>

            <button className="btn btn-outline-light me-2" onClick={() => setPage("deposit")}>
              Deposit
            </button>

            <button className="btn btn-outline-light me-2" onClick={() => setPage("withdraw")}>
              Withdraw
            </button>

            <button className="btn btn-outline-light" onClick={() => setPage("users")}>
              All Users
            </button>
          </div>
        </div>
      </nav>

      <div className="container mt-4">

        {/* HOME */}
{page === "home" && (
  <div className="card p-4 shadow text-center">
    <h2>Welcome to Mini Bank 🏦</h2>
    <p>Use the navbar to perform operations</p>
  </div>
)}

        {/* CREATE USER */}
        {page === "create" && (
          <div className="card p-4 shadow">
            <h3>Create User</h3>

            <input className="form-control my-2" name="email" placeholder="Email" onChange={handleChange} />
            <input className="form-control my-2" name="password" placeholder="Password" onChange={handleChange} />
            <input className="form-control my-2" name="phone" placeholder="Phone" onChange={handleChange} />
            <input className="form-control my-2" name="name" placeholder="Name" onChange={handleChange} />

            <button className="btn btn-primary" onClick={createUser}>
              Create User
            </button>
          </div>
        )}

        {/* DEPOSIT */}
        {page === "deposit" && (
          <div className="card p-4 shadow">
            <h3>Deposit</h3>

            <input className="form-control my-2" name="email" placeholder="Email" onChange={handleChange} />
            <input className="form-control my-2" name="amount" placeholder="Amount" onChange={handleChange} />

            <button className="btn btn-success" onClick={deposit}>
              Deposit
            </button>
          </div>
        )}

        {/* WITHDRAW */}
        {page === "withdraw" && (
          <div className="card p-4 shadow">
            <h3>Withdraw</h3>

            <input className="form-control my-2" name="email" placeholder="Email" onChange={handleChange} />
            <input className="form-control my-2" name="amount" placeholder="Amount" onChange={handleChange} />

            <button className="btn btn-danger" onClick={withdraw}>
              Withdraw
            </button>
          </div>
        )}

        {/* USERS TABLE */}
        {page === "users" && (
          <div className="card p-4 shadow">
            <h3>All Users</h3>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Password</th>
                  <th>Balance</th>
                </tr>
              </thead>

              <tbody>
                {users.map((u, i) => (
                  <tr key={i}>
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td>{u.phone}</td>
                    <td>{u.password}</td>
                    <td>{u.balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      </div>
    </div>
  );
}

export default App;